import type { IGrade, IListResponse } from '@dakedake/types'
import { request } from '@umijs/max'

/** 添加分级 POST /backend/grade/add */
export async function gradeAdd(body: IGrade, options?: Record<string, any>) {
  return request<{ data: IGrade, status: number, message: string }>('/backend/grade/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 删除分级 POST /backend/grade/delete */
export async function gradeDelete(body: { id: number }, options?: Record<string, any>) {
  return request<{ data: IGrade, status: number, message: string }>('/backend/grade/delete', {
    method: 'DELETE',
    data: body,
    ...options
  })
}

/** 获取分级列表 GET /backend/grade/list */
export async function gradeList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
  },
  options?: Record<string, any>
) {
  return request<IListResponse<IGrade>>('/backend/grade/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}
